export default "__VITE_ASSET__C5enZ6of__"